export const openInNewTab = (url: string, focus = false) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer")
  if (newWindow) {
    newWindow.opener = null
    focus && newWindow.focus()
  }
}
